import parsePhoneNumber from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumber: string) {
  // Handle phone extensions (separated by ; or ,)
  const extensionRegex = /^([^;,]+)[;,](.+)$/;
  const extensionMatch = extensionRegex.exec(phoneNumber);
  const baseNumber = extensionMatch?.[1] ?? phoneNumber;
  const extension = extensionMatch?.[2] ?? null;

  let formattedBase: string;

  if (isValidE164Format(baseNumber)) {
    formattedBase = parsePhoneNumber(baseNumber)?.formatNational() || baseNumber;
  } else {
    const fullNumber = baseNumber.replace(/\D/g, '');
    if (fullNumber.length === 0) {
      formattedBase = fullNumber;
    } else if (fullNumber.length < 4) {
      formattedBase = fullNumber;
    } else if (fullNumber.length < 7) {
      formattedBase = `(${fullNumber.slice(0, 3)}) ${fullNumber.slice(3)}`;
    } else if (fullNumber.length === 7) {
      formattedBase = `${fullNumber.slice(0, 3)}-${fullNumber.slice(3)}`;
    } else {
      formattedBase = `(${fullNumber.slice(0, 3)}) ${fullNumber.slice(3, 6)}-${fullNumber.slice(6, 10)}`;
    }
  }

  if (extension) {
    // Sanitize extension to only allow digits
    const sanitizedExtension = extension.replace(/\D/g, '');
    if (sanitizedExtension) {
      return `${formattedBase} ext. ${sanitizedExtension}`;
    }
  }
  return formattedBase;
}

function isValidE164Format(phoneNumber: string) {
  const regex = /^\+[1-9]\d{10,14}$/;
  return regex.test(phoneNumber);
}

export function toTitleCase(str: string) {
  if (str.length === 0) return str;
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
}

export function snakeCaseToTitleCase(str: string) {
  return str.split('_').map(toTitleCase).join(' ');
}

export function toNumberWithCommas(num: number | string): string {
  const cleanedInput = num.toString().replace(/\D/g, '');
  // Format number with commas
  return cleanedInput.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
